<template>
<ItpBox
  alignItems="center"
  class="items-spacing w-100"
  v-if="loaded"
>
  <ItpBox
    direction="column"
  >
    <ItpText
      muted
      class="mb-0"
    >
      {{ resourceTitle }}
    </ItpText>
    <ItpText
      tag="h4"
      :text="resourceKey"
      class="mb-0"
    >
    </ItpText>
  </ItpBox>
  <UcInvoiceTypeBadge
    :value="invoice.invoice_type"
    :kind="invoice.invoice_kind"
    :advance="invoice.is_advance"
  >
  </UcInvoiceTypeBadge>
  <UcInvoiceStatusBadge
    :value="invoice.status"
  >
  </UcInvoiceStatusBadge>
  <DIV
    v-if="invoice.tags && invoice.tags.length"
  >
    <span
      class="badge badge-secondary mx-1 shadow-none"
      v-for="tag in invoice.tags"
    >
      {{ tag }}
    </span>
  </DIV>
  <DIV
    :title="'Closed'|gettext"
    v-if="invoice.isReadOnly"
  >
    <ItpIcon
      :icon="$config.lockIcon"
    >
    </ItpIcon>
  </DIV>
  <DIV
    class="text-green-500"
    v-if="invoice.authority_transaction_id"
  >
    <DIV
      :title="invoice.authority_transaction_id"
    >
      <ItpIcon
        icon="fluent:cloud-sync-complete-16-regular"
      >
      </ItpIcon>
    </DIV>
    <DIV
      :title="JSON.stringify(invoice.authority_transaction_status)"
    >
      <ItpIcon
        icon="fa-question-circle"
      >
      </ItpIcon>
    </DIV>
  </DIV>
  <ItpBox
    direction="column"
    v-if="invoice.reference_invoice"
  >
    <ItpText
      muted
      class="mb-0"
    >
      {{ 'Reference invoice'|pgettext('Invoice') }}
    </ItpText>
    <UcInvoiceMiniCard
      :item="invoice.reference_invoice"
      no-icon
    >
    </UcInvoiceMiniCard>
  </ItpBox>
  <ItpBox
    direction="column"
    v-if="invoice.referencing_invoices && invoice.referencing_invoices.length"
  >
    <ItpText
      muted
      class="mb-0"
    >
      {{ 'Referencing invoices'|pgettext('Invoice') }}
    </ItpText>
    <ItpBox>
      <UcInvoiceMiniCard
        :key="obj.id"
        :item="obj"
        no-icon
        class="mr-2"
        v-for="obj in invoice.referencing_invoices"
      >
      </UcInvoiceMiniCard>
    </ItpBox>
  </ItpBox>
  <Icon
    :icon="'flagpack:' + invoice.language"
    :title="'Invoice Language'|pgettext('Invoice')"
    v-if="!invoice.isNew"
  >
  </Icon>
  <DIV
    class="btn-toolbar ml-auto flex-nowrap"
  >
    <BtnIssueInvoice
      :invoice="invoice"
      class="ml-auto mr-2"
      v-if="invoice.meta && invoice.meta.issuance_status.status == 'not_started'"
      @success="evh_3573211234170528_success($event, {})"
    >
    </BtnIssueInvoice>
    <BtnSyncInvoice
      :invoice="invoice"
      class="ml-auto mr-2"
      v-if="invoice.meta && invoice.meta.billing_service_status.status == 'not_started'"
      @success="evh_3350181908999980_success($event, {})"
    >
    </BtnSyncInvoice>
    <BtnReportInvoiceData
      :resource="invoice"
      class="ml-auto mr-2"
      v-if="invoice.meta && (invoice.meta.data_reporting_status.status == 'not_started' || invoice.meta.data_reporting_status.status == 'error')"
      @success="evh_5626515103939381_success($event, {})"
    >
    </BtnReportInvoiceData>
    <BtnSyncResource
      :resource="invoice"
      target="irent"
      confirmMessage="A számlát csak egyszer lehet felölteni a régi rendszerbe,
feltöltés után a számlát már nem lehet módosítani."
      class="ml-auto mr-2"
      v-if="invoice.meta && invoice.meta.sync_to_external_system_status.status == 'not_started'"
      @success="evh_5072463219534047_success($event, {})"
    >
    </BtnSyncResource>
    <ItpButton
      :icon="$config.editIcon"
      :tooltip="'Edit'|gettext"
      variant="light"
      class="ml-auto mr-2"
      v-if="!invoice.isNew && !invoice.isReadOnly"
      @click.prevent.stop="evh_5450657804282831_clickPreventStop($event, {})"
    >
    </ItpButton>
    <ItpButton
      icon="fa-sync-alt"
      :tooltip="'Reload'|gettext"
      :spinning="actions.reload.isRunning"
      variant="light"
      class="ml-auto mr-2"
      v-if="!invoice.isNew"
      @click.prevent.stop="evh_995920279152457_clickPreventStop($event, {})"
    >
    </ItpButton>
    <UcInvoiceViewDocumentDropdown
      :invoice="invoice"
      class="ml-auto mr-2"
      @click.prevent.stop="evh_8434031504612555_clickPreventStop($event, {})"
    >
    </UcInvoiceViewDocumentDropdown>
    <ItpButton
      variant="light"
      icon="icon-park-outline:preview-open"
      :href="invoice.preview_url"
      :tooltip="'Open preview'|pgettext('Invoice')"
      target="_blank"
      use-auth
      show-spinner
      class="ml-auto mr-2"
      v-if="invoice.preview_url"
    >
    </ItpButton>
    <ItpButton
      variant="light"
      icon="icon-park-outline:log"
      :tooltip="'Show log messages'|pgettext('Invoice')"
      class="ml-auto mr-2"
      v-if="invoice.log_messages"
      @click.prevent.stop="evh_1246756660686207_clickPreventStop($event, {})"
    >
    </ItpButton>
    <b-dropdown
      right
      variant="light"
      no-caret
      class="border"
      v-if="!invoice.isNew"
    >
      <ItpIcon
        fa="bars"
        class="mx-1"
        slot="button-content"
      >
      </ItpIcon>
      <ItpButton
        dropdown-item
        :text="'Register invoice'|pgettext('Invoice')"
        :tooltip="'Add this invoice to the invoice register'|pgettext('Invoice')"
        variant="default"
        v-if="invoiceIsRegistrable"
        @click="evh_932298791746317_click($event, {})"
      >
      </ItpButton>
      <ItpButton
        dropdown-item
        :text="'Copy'|pgettext('BtnCopyResource')"
        :tooltip="'Create new invoice from this one'|pgettext('Invoice')"
        variant="default"
        @click="evh_2674698048827991_click($event, {})"
      >
      </ItpButton>
      <ItpButton
        dropdown-item
        :text="'Create pass-through'|pgettext('Invoice')"
        :tooltip="messages.createPassThroughTooltip"
        variant="default"
        :disabled="!invoicePassThroughIsEnabled"
        v-if="!invoice.isNew"
        @click="evh_2252498968068653_click($event, {})"
      >
      </ItpButton>
      <ItpButton
        dropdown-item
        :text="'Create advance'|pgettext('Invoice')"
        :tooltip="messages.createAdvanceInvoiceTooltip"
        variant="default"
        :disabled="!canCreateAdvanceInvoice"
        v-if="!invoice.isNew"
        @click="evh_3512640571721973_click($event, {})"
      >
      </ItpButton>
      <ItpButton
        dropdown-item
        :text="'Create final'|pgettext('Invoice')"
        :tooltip="messages.createFinalInvoiceTooltip"
        variant="default"
        :disabled="!canCreateFinalInvoice"
        v-if="!invoice.isNew"
        @click="evh_6424219584985303_click($event, {})"
      >
      </ItpButton>
      <hr>
      </hr>
      <ItpButton
        dropdown-item
        :text="'Create storno'|pgettext('Invoice')"
        :tooltip="createStornoTooltip"
        variant="default"
        :disabled="!invoiceIsReversible"
        v-if="!invoice.isNew"
        @click="evh_6886333622481462_click($event, {})"
      >
      </ItpButton>
      <ItpButton
        dropdown-item
        variant="default"
        :text="'Create corrector'|pgettext('Invoice')"
        :tooltip="createCorrectorTooltip"
        :disabled="!invoiceIsModifiable"
        v-if="!invoice.isNew"
        @click="evh_6074864154397733_click($event, {})"
      >
      </ItpButton>
      <BtnLockResource
        no-icon
        dropdown-item
        :resource="invoice"
        :tooltip="'Lock invoice'|pgettext('Invoice')"
        v-if="!invoice.isNew && !invoice.isReadOnly"
        @success="evh_8797352275194556_success($event, {})"
      >
      </BtnLockResource>
      <BtnDeleteResource
        no-icon
        dropdown-item
        :resource="invoice"
        :tooltip="'Delete invoice'|pgettext('Invoice')"
        v-if="!invoice.isNew && !invoice.isReadOnly"
        @success="evh_6679522740328543_success($event, {})"
      >
      </BtnDeleteResource>
      <hr>
      </hr>
      <ItpButton
        dropdown-item
        :text="'History'|pgettext('BtnResourceHistory')"
        :tooltip="'Invoice history'|pgettext('Invoice')"
        variant="default"
        @click.prevent.stop="evh_4848747000340100_clickPreventStop($event, {})"
      >
      </ItpButton>
    </b-dropdown>
  </DIV>
</ItpBox>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcInvoiceHeader extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  invoice!: object;

  @Watch('invoice')
  onInvoice(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("invoice")
  }

  @Prop({
    type: String,
    default: function() {
      return this.$fn.randomElementId()
    },
  })
  formId!: string;

  @Watch('formId')
  onForm_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("formId")
  }

  @Prop({
    type: String,
  })
  invoiceNumber!: string;

  @Watch('invoiceNumber')
  onInvoice_number(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("invoiceNumber")
  }

  @Prop({
    required: true,
    type: Object,
  })
  formContext!: object;

  @Watch('formContext')
  onForm_context(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("formContext")
  }

  messages!: any;
  ux!: any;
  dataMembers = ['messages', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        messages: {
          newTransaction: this.$fn.pgettext("Invoice", "New Invoice"),
          invoiceKind: {
            incoming: this.$fn.pgettext("InvoiceKind", "Incoming Invoice"),
            outgoing: this.$fn.pgettext("InvoiceKind", "Outgoing Invoice"),
          }
          ,
          createCorrectorTooltip: this.$fn.pgettext("Invoice", "Create corrector invoice"),
          createStornoTooltip: this.$fn.pgettext("Invoice", "Create storno invoice"),
          createPassThroughTooltip: this.$fn.pgettext("Invoice|Tooltip", "Rebilling the line items to a designated client."),
          createAdvanceInvoiceTooltip: this.$fn.pgettext("Invoice|Tooltip", "Create advance invoice from a Pro Forma invoice."),
          createFinalInvoiceTooltip: this.$fn.pgettext("Invoice|Tooltip", "Create final invoice from a Pro Forma or advance invoice."),
        }
        ,
        ux: null,
      },
    }
  }

  get resourceTitle() {
    if (this.loaded) {

      return this.messages.invoiceKind[this.invoice.invoice_kind]
    }
    return null;
  }

  get resourceKey() {
    if (this.loaded) {

      return this.invoiceNumber || (this.invoice.isNew ? this.messages.newTransaction : this.invoice.invoice_number)
    }
    return null;
  }

  get createCorrectorTooltip() {
    if (this.loaded) {

      return _.get(this.invoice, 'meta.modifiable.message') || this.messages.createCorrectorTooltip
    }
    return null;
  }

  get createStornoTooltip() {
    if (this.loaded) {

      return _.get(this.invoice, 'meta.reversible.message') || this.messages.createStornoTooltip
    }
    return null;
  }

  get invoiceIsReversible() {
    if (this.loaded) {

      return _.get(this.invoice, 'meta.reversible.result')
    }
    return null;
  }

  get invoiceIsModifiable() {
    if (this.loaded) {

      return _.get(this.invoice, 'meta.modifiable.result')
    }
    return null;
  }

  get invoiceIsRegistrable() {
    if (this.loaded) {

      return _.get(this.invoice, 'meta.registrable.result')
    }
    return null;
  }

  get invoicePassThroughIsEnabled() {
    if (this.loaded) {

      return _.get(this.invoice, 'meta.pass_through_enabled') === true ||
        _.get(this.invoice, 'meta.pass_through_enabled.result')
    }
    return null;
  }

  get canCreateAdvanceInvoice() {
    if (this.loaded) {

      return _.get(this.invoice, 'meta.can_create_advance_invoice') === true
    }
    return null;
  }

  get canCreateFinalInvoice() {
    if (this.loaded) {

      return _.get(this.invoice, 'meta.can_create_final_invoice') === true
    }
    return null;
  }

  async act_3573211234170528_emit_7296_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_3573211234170528_emit_7296, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_3573211234170528_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3573211234170528_success.executeFromDOM(this, event, scope);
  }

  async act_3350181908999980_emit_7298_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_3350181908999980_emit_7298, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_3350181908999980_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3350181908999980_success.executeFromDOM(this, event, scope);
  }

  async act_5626515103939381_emit_7300_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_5626515103939381_emit_7300, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_5626515103939381_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5626515103939381_success.executeFromDOM(this, event, scope);
  }

  async act_5072463219534047_emit_7302_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_5072463219534047_emit_7302, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_5072463219534047_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5072463219534047_success.executeFromDOM(this, event, scope);
  }

  async act_5450657804282831_emit_7306_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_5450657804282831_emit_7306, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_5450657804282831_close_7305_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_5450657804282831_close_7305, alias=undefined
    return $event.data.modalResult.ok
  }

  async act_5450657804282831_showModal_7304_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_5450657804282831_showModal_7304, alias=undefined
    return {
      name: "InvoiceEditor",
      props: {
        invoice: _.cloneDeep(this.invoice),
      }
      ,
    }
  }

  async evh_5450657804282831_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5450657804282831_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_995920279152457_emit_7308_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_995920279152457_emit_7308, alias=reload
    return {
      event: "reload",
    }
  }

  async evh_995920279152457_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_995920279152457_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_8434031504612555_emit_7310_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_8434031504612555_emit_7310, alias=reload
    return {
      event: "reload",
    }
  }

  async evh_8434031504612555_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8434031504612555_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_1246756660686207_showModal_7312_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_1246756660686207_showModal_7312, alias=undefined
    return {
      name: "InvoiceLogMessageViewer",
      props: {
        invoiceId: this.invoice.id,
      }
      ,
    }
  }

  async evh_1246756660686207_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1246756660686207_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_932298791746317_emit_7316_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_932298791746317_emit_7316, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_932298791746317_close_7315_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_932298791746317_close_7315, alias=undefined
    return $event.data.modalResult.ok
  }

  async act_932298791746317_showModal_7314_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_932298791746317_showModal_7314, alias=registerInvoice
    return {
      name: "RegisterEntry",
      props: {
        invoice: this.invoice,
      }
      ,
    }
  }

  async evh_932298791746317_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_932298791746317_click.executeFromDOM(this, event, scope);
  }

  async act_2674698048827991_emit_7320_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_2674698048827991_emit_7320, alias=undefined
    return {
      event: "created",
      value: $event.data.response.data,
    }
  }

  async act_2674698048827991_request_7318_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_2674698048827991_request_7318, alias=createInvoicecopy
    return {
      operation: "create_invoice",
      data: { invoice_id: this.invoice.id, invoice_type: 'copy' },
    }
  }

  async evh_2674698048827991_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2674698048827991_click.executeFromDOM(this, event, scope);
  }

  async act_2252498968068653_emit_7324_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_2252498968068653_emit_7324, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_2252498968068653_close_7323_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2252498968068653_close_7323, alias=undefined
    return $event.data.modalResult.ok
  }

  async act_2252498968068653_showModal_7322_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_2252498968068653_showModal_7322, alias=createPassThroughInvoice
    return {
      name: "CreatePassThroughInvoice",
      props: {
        invoice: this.invoice,
      }
      ,
    }
  }

  async evh_2252498968068653_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2252498968068653_click.executeFromDOM(this, event, scope);
  }

  async act_3512640571721973_emit_7328_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_3512640571721973_emit_7328, alias=undefined
    return {
      event: "created",
      value: $event.data.response.data,
    }
  }

  async act_3512640571721973_request_7326_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_3512640571721973_request_7326, alias=createAdvanceInvoice
    return {
      operation: "create_invoice",
      data: { invoice_id: this.invoice.id, invoice_type: 'advance' },
    }
  }

  async evh_3512640571721973_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3512640571721973_click.executeFromDOM(this, event, scope);
  }

  async act_6424219584985303_emit_7332_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_6424219584985303_emit_7332, alias=undefined
    return {
      event: "created",
      value: $event.data.response.data,
    }
  }

  async act_6424219584985303_request_7330_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_6424219584985303_request_7330, alias=createFinalInvoice
    return {
      operation: "create_invoice",
      data: { invoice_id: this.invoice.id, invoice_type: 'final' },
    }
  }

  async evh_6424219584985303_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6424219584985303_click.executeFromDOM(this, event, scope);
  }

  async act_6886333622481462_emit_7336_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_6886333622481462_emit_7336, alias=undefined
    return {
      event: "created",
      value: $event.data.response.data,
    }
  }

  async act_6886333622481462_request_7334_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_6886333622481462_request_7334, alias=createStornoInvoice
    return {
      operation: "create_invoice",
      data: { invoice_id: this.invoice.id, invoice_type: 'storno' },
    }
  }

  async evh_6886333622481462_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6886333622481462_click.executeFromDOM(this, event, scope);
  }

  async act_6074864154397733_emit_7340_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_6074864154397733_emit_7340, alias=undefined
    return {
      event: "created",
      value: $event.data.response.data,
    }
  }

  async act_6074864154397733_request_7338_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_6074864154397733_request_7338, alias=createCorrectorIvoice
    return {
      operation: "create_invoice",
      data: {
        invoice_id: this.invoice.id,
        invoice_type: 'correction',
        invoice_lines: _.map(this.formContext.selectedInvoiceLines, p => p.id).join(',')
      },
    }
  }

  async evh_6074864154397733_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6074864154397733_click.executeFromDOM(this, event, scope);
  }

  async act_8797352275194556_emit_7342_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_8797352275194556_emit_7342, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_8797352275194556_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8797352275194556_success.executeFromDOM(this, event, scope);
  }

  async act_6679522740328543_emit_7344_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_6679522740328543_emit_7344, alias=undefined
    return {
      event: "deleted",
    }
  }

  async evh_6679522740328543_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6679522740328543_success.executeFromDOM(this, event, scope);
  }

  async act_4848747000340100_showModal_7346_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_4848747000340100_showModal_7346, alias=undefined
    return {
      name: "entityEvents",
      props: {
        entityId: this.invoice.id,
      }
      ,
    }
  }

  async evh_4848747000340100_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4848747000340100_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_3573211234170528_emit_7296: actions.EmitAction;
    evh_3573211234170528_success_7295: actions.EventHandlerImpl;
    evh_3573211234170528_success: actions.EventHandlerGroup;
    act_3350181908999980_emit_7298: actions.EmitAction;
    evh_3350181908999980_success_7297: actions.EventHandlerImpl;
    evh_3350181908999980_success: actions.EventHandlerGroup;
    act_5626515103939381_emit_7300: actions.EmitAction;
    evh_5626515103939381_success_7299: actions.EventHandlerImpl;
    evh_5626515103939381_success: actions.EventHandlerGroup;
    act_5072463219534047_emit_7302: actions.EmitAction;
    evh_5072463219534047_success_7301: actions.EventHandlerImpl;
    evh_5072463219534047_success: actions.EventHandlerGroup;
    act_5450657804282831_emit_7306: actions.EmitAction;
    evh_5450657804282831_close_7305: actions.EventHandlerImpl;
    act_5450657804282831_showModal_7304: actions.ShowModalAction;
    evh_5450657804282831_clickPreventStop_7303: actions.EventHandlerImpl;
    evh_5450657804282831_clickPreventStop: actions.EventHandlerGroup;
    act_995920279152457_emit_7308: actions.EmitAction;
    evh_995920279152457_clickPreventStop_7307: actions.EventHandlerImpl;
    evh_995920279152457_clickPreventStop: actions.EventHandlerGroup;
    act_8434031504612555_emit_7310: actions.EmitAction;
    evh_8434031504612555_clickPreventStop_7309: actions.EventHandlerImpl;
    evh_8434031504612555_clickPreventStop: actions.EventHandlerGroup;
    act_1246756660686207_showModal_7312: actions.ShowModalAction;
    evh_1246756660686207_clickPreventStop_7311: actions.EventHandlerImpl;
    evh_1246756660686207_clickPreventStop: actions.EventHandlerGroup;
    act_932298791746317_emit_7316: actions.EmitAction;
    evh_932298791746317_close_7315: actions.EventHandlerImpl;
    act_932298791746317_showModal_7314: actions.ShowModalAction;
    evh_932298791746317_click_7313: actions.EventHandlerImpl;
    evh_932298791746317_click: actions.EventHandlerGroup;
    act_2674698048827991_emit_7320: actions.EmitAction;
    evh_2674698048827991_success_7319: actions.EventHandlerImpl;
    act_2674698048827991_request_7318: actions.RequestAction;
    evh_2674698048827991_click_7317: actions.EventHandlerImpl;
    evh_2674698048827991_click: actions.EventHandlerGroup;
    act_2252498968068653_emit_7324: actions.EmitAction;
    evh_2252498968068653_close_7323: actions.EventHandlerImpl;
    act_2252498968068653_showModal_7322: actions.ShowModalAction;
    evh_2252498968068653_click_7321: actions.EventHandlerImpl;
    evh_2252498968068653_click: actions.EventHandlerGroup;
    act_3512640571721973_emit_7328: actions.EmitAction;
    evh_3512640571721973_success_7327: actions.EventHandlerImpl;
    act_3512640571721973_request_7326: actions.RequestAction;
    evh_3512640571721973_click_7325: actions.EventHandlerImpl;
    evh_3512640571721973_click: actions.EventHandlerGroup;
    act_6424219584985303_emit_7332: actions.EmitAction;
    evh_6424219584985303_success_7331: actions.EventHandlerImpl;
    act_6424219584985303_request_7330: actions.RequestAction;
    evh_6424219584985303_click_7329: actions.EventHandlerImpl;
    evh_6424219584985303_click: actions.EventHandlerGroup;
    act_6886333622481462_emit_7336: actions.EmitAction;
    evh_6886333622481462_success_7335: actions.EventHandlerImpl;
    act_6886333622481462_request_7334: actions.RequestAction;
    evh_6886333622481462_click_7333: actions.EventHandlerImpl;
    evh_6886333622481462_click: actions.EventHandlerGroup;
    act_6074864154397733_emit_7340: actions.EmitAction;
    evh_6074864154397733_success_7339: actions.EventHandlerImpl;
    act_6074864154397733_request_7338: actions.RequestAction;
    evh_6074864154397733_click_7337: actions.EventHandlerImpl;
    evh_6074864154397733_click: actions.EventHandlerGroup;
    act_8797352275194556_emit_7342: actions.EmitAction;
    evh_8797352275194556_success_7341: actions.EventHandlerImpl;
    evh_8797352275194556_success: actions.EventHandlerGroup;
    act_6679522740328543_emit_7344: actions.EmitAction;
    evh_6679522740328543_success_7343: actions.EventHandlerImpl;
    evh_6679522740328543_success: actions.EventHandlerGroup;
    act_4848747000340100_showModal_7346: actions.ShowModalAction;
    evh_4848747000340100_clickPreventStop_7345: actions.EventHandlerImpl;
    evh_4848747000340100_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_3573211234170528_emit_7296 = new actions.EmitAction(
      {
        actionArgs: this.act_3573211234170528_emit_7296_getActionArgs,
        events: [],
      }
    );
    const evh_3573211234170528_success_7295 = new actions.EventHandlerImpl(
      {
        action: act_3573211234170528_emit_7296,
        event: "success",
        displayName: "emit",
      }
    );
    const evh_3573211234170528_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_3573211234170528_success_7295],
      }
    );
    const act_3350181908999980_emit_7298 = new actions.EmitAction(
      {
        actionArgs: this.act_3350181908999980_emit_7298_getActionArgs,
        events: [],
      }
    );
    const evh_3350181908999980_success_7297 = new actions.EventHandlerImpl(
      {
        action: act_3350181908999980_emit_7298,
        event: "success",
        displayName: "emit",
      }
    );
    const evh_3350181908999980_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_3350181908999980_success_7297],
      }
    );
    const act_5626515103939381_emit_7300 = new actions.EmitAction(
      {
        actionArgs: this.act_5626515103939381_emit_7300_getActionArgs,
        events: [],
      }
    );
    const evh_5626515103939381_success_7299 = new actions.EventHandlerImpl(
      {
        action: act_5626515103939381_emit_7300,
        event: "success",
        displayName: "emit",
      }
    );
    const evh_5626515103939381_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_5626515103939381_success_7299],
      }
    );
    const act_5072463219534047_emit_7302 = new actions.EmitAction(
      {
        actionArgs: this.act_5072463219534047_emit_7302_getActionArgs,
        events: [],
      }
    );
    const evh_5072463219534047_success_7301 = new actions.EventHandlerImpl(
      {
        action: act_5072463219534047_emit_7302,
        event: "success",
        displayName: "emit",
      }
    );
    const evh_5072463219534047_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_5072463219534047_success_7301],
      }
    );
    const act_5450657804282831_emit_7306 = new actions.EmitAction(
      {
        actionArgs: this.act_5450657804282831_emit_7306_getActionArgs,
        events: [],
      }
    );
    const evh_5450657804282831_close_7305 = new actions.EventHandlerImpl(
      {
        action: act_5450657804282831_emit_7306,
        event: "close",
        when: this.evh_5450657804282831_close_7305_getWhen,
        displayName: "emit",
      }
    );
    const act_5450657804282831_showModal_7304 = new actions.ShowModalAction(
      {
        actionArgs: this.act_5450657804282831_showModal_7304_getActionArgs,
        events: [evh_5450657804282831_close_7305],
      }
    );
    const evh_5450657804282831_clickPreventStop_7303 = new actions.EventHandlerImpl(
      {
        action: act_5450657804282831_showModal_7304,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_5450657804282831_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_5450657804282831_clickPreventStop_7303],
      }
    );
    const act_995920279152457_emit_7308 = new actions.EmitAction(
      {
        actionArgs: this.act_995920279152457_emit_7308_getActionArgs,
        displayName: "reload",
        events: [],
      }
    );
    const evh_995920279152457_clickPreventStop_7307 = new actions.EventHandlerImpl(
      {
        action: act_995920279152457_emit_7308,
        event: "click.prevent.stop",
        displayName: "reload",
      }
    );
    const evh_995920279152457_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_995920279152457_clickPreventStop_7307],
      }
    );
    const act_8434031504612555_emit_7310 = new actions.EmitAction(
      {
        actionArgs: this.act_8434031504612555_emit_7310_getActionArgs,
        displayName: "reload",
        events: [],
      }
    );
    const evh_8434031504612555_clickPreventStop_7309 = new actions.EventHandlerImpl(
      {
        action: act_8434031504612555_emit_7310,
        event: "click.prevent.stop",
        displayName: "reload",
      }
    );
    const evh_8434031504612555_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_8434031504612555_clickPreventStop_7309],
      }
    );
    const act_1246756660686207_showModal_7312 = new actions.ShowModalAction(
      {
        actionArgs: this.act_1246756660686207_showModal_7312_getActionArgs,
        events: [],
      }
    );
    const evh_1246756660686207_clickPreventStop_7311 = new actions.EventHandlerImpl(
      {
        action: act_1246756660686207_showModal_7312,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_1246756660686207_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1246756660686207_clickPreventStop_7311],
      }
    );
    const act_932298791746317_emit_7316 = new actions.EmitAction(
      {
        actionArgs: this.act_932298791746317_emit_7316_getActionArgs,
        events: [],
      }
    );
    const evh_932298791746317_close_7315 = new actions.EventHandlerImpl(
      {
        action: act_932298791746317_emit_7316,
        event: "close",
        when: this.evh_932298791746317_close_7315_getWhen,
        displayName: "emit",
      }
    );
    const act_932298791746317_showModal_7314 = new actions.ShowModalAction(
      {
        actionArgs: this.act_932298791746317_showModal_7314_getActionArgs,
        displayName: "registerInvoice",
        events: [evh_932298791746317_close_7315],
      }
    );
    const evh_932298791746317_click_7313 = new actions.EventHandlerImpl(
      {
        action: act_932298791746317_showModal_7314,
        event: "click",
        displayName: "registerInvoice",
      }
    );
    const evh_932298791746317_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_932298791746317_click_7313],
      }
    );
    const act_2674698048827991_emit_7320 = new actions.EmitAction(
      {
        actionArgs: this.act_2674698048827991_emit_7320_getActionArgs,
        events: [],
      }
    );
    const evh_2674698048827991_success_7319 = new actions.EventHandlerImpl(
      {
        action: act_2674698048827991_emit_7320,
        event: "success",
        displayName: "emit",
      }
    );
    const act_2674698048827991_request_7318 = new actions.RequestAction(
      {
        actionArgs: this.act_2674698048827991_request_7318_getActionArgs,
        displayName: "createInvoicecopy",
        events: [evh_2674698048827991_success_7319],
      }
    );
    const evh_2674698048827991_click_7317 = new actions.EventHandlerImpl(
      {
        action: act_2674698048827991_request_7318,
        event: "click",
        displayName: "createInvoicecopy",
      }
    );
    const evh_2674698048827991_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_2674698048827991_click_7317],
      }
    );
    const act_2252498968068653_emit_7324 = new actions.EmitAction(
      {
        actionArgs: this.act_2252498968068653_emit_7324_getActionArgs,
        events: [],
      }
    );
    const evh_2252498968068653_close_7323 = new actions.EventHandlerImpl(
      {
        action: act_2252498968068653_emit_7324,
        event: "close",
        when: this.evh_2252498968068653_close_7323_getWhen,
        displayName: "emit",
      }
    );
    const act_2252498968068653_showModal_7322 = new actions.ShowModalAction(
      {
        actionArgs: this.act_2252498968068653_showModal_7322_getActionArgs,
        displayName: "createPassThroughInvoice",
        events: [evh_2252498968068653_close_7323],
      }
    );
    const evh_2252498968068653_click_7321 = new actions.EventHandlerImpl(
      {
        action: act_2252498968068653_showModal_7322,
        event: "click",
        displayName: "createPassThroughInvoice",
      }
    );
    const evh_2252498968068653_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_2252498968068653_click_7321],
      }
    );
    const act_3512640571721973_emit_7328 = new actions.EmitAction(
      {
        actionArgs: this.act_3512640571721973_emit_7328_getActionArgs,
        events: [],
      }
    );
    const evh_3512640571721973_success_7327 = new actions.EventHandlerImpl(
      {
        action: act_3512640571721973_emit_7328,
        event: "success",
        displayName: "emit",
      }
    );
    const act_3512640571721973_request_7326 = new actions.RequestAction(
      {
        actionArgs: this.act_3512640571721973_request_7326_getActionArgs,
        displayName: "createAdvanceInvoice",
        events: [evh_3512640571721973_success_7327],
      }
    );
    const evh_3512640571721973_click_7325 = new actions.EventHandlerImpl(
      {
        action: act_3512640571721973_request_7326,
        event: "click",
        displayName: "createAdvanceInvoice",
      }
    );
    const evh_3512640571721973_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_3512640571721973_click_7325],
      }
    );
    const act_6424219584985303_emit_7332 = new actions.EmitAction(
      {
        actionArgs: this.act_6424219584985303_emit_7332_getActionArgs,
        events: [],
      }
    );
    const evh_6424219584985303_success_7331 = new actions.EventHandlerImpl(
      {
        action: act_6424219584985303_emit_7332,
        event: "success",
        displayName: "emit",
      }
    );
    const act_6424219584985303_request_7330 = new actions.RequestAction(
      {
        actionArgs: this.act_6424219584985303_request_7330_getActionArgs,
        displayName: "createFinalInvoice",
        events: [evh_6424219584985303_success_7331],
      }
    );
    const evh_6424219584985303_click_7329 = new actions.EventHandlerImpl(
      {
        action: act_6424219584985303_request_7330,
        event: "click",
        displayName: "createFinalInvoice",
      }
    );
    const evh_6424219584985303_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_6424219584985303_click_7329],
      }
    );
    const act_6886333622481462_emit_7336 = new actions.EmitAction(
      {
        actionArgs: this.act_6886333622481462_emit_7336_getActionArgs,
        events: [],
      }
    );
    const evh_6886333622481462_success_7335 = new actions.EventHandlerImpl(
      {
        action: act_6886333622481462_emit_7336,
        event: "success",
        displayName: "emit",
      }
    );
    const act_6886333622481462_request_7334 = new actions.RequestAction(
      {
        actionArgs: this.act_6886333622481462_request_7334_getActionArgs,
        displayName: "createStornoInvoice",
        events: [evh_6886333622481462_success_7335],
      }
    );
    const evh_6886333622481462_click_7333 = new actions.EventHandlerImpl(
      {
        action: act_6886333622481462_request_7334,
        event: "click",
        displayName: "createStornoInvoice",
      }
    );
    const evh_6886333622481462_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_6886333622481462_click_7333],
      }
    );
    const act_6074864154397733_emit_7340 = new actions.EmitAction(
      {
        actionArgs: this.act_6074864154397733_emit_7340_getActionArgs,
        events: [],
      }
    );
    const evh_6074864154397733_success_7339 = new actions.EventHandlerImpl(
      {
        action: act_6074864154397733_emit_7340,
        event: "success",
        displayName: "emit",
      }
    );
    const act_6074864154397733_request_7338 = new actions.RequestAction(
      {
        actionArgs: this.act_6074864154397733_request_7338_getActionArgs,
        displayName: "createCorrectorIvoice",
        events: [evh_6074864154397733_success_7339],
      }
    );
    const evh_6074864154397733_click_7337 = new actions.EventHandlerImpl(
      {
        action: act_6074864154397733_request_7338,
        event: "click",
        displayName: "createCorrectorIvoice",
      }
    );
    const evh_6074864154397733_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_6074864154397733_click_7337],
      }
    );
    const act_8797352275194556_emit_7342 = new actions.EmitAction(
      {
        actionArgs: this.act_8797352275194556_emit_7342_getActionArgs,
        events: [],
      }
    );
    const evh_8797352275194556_success_7341 = new actions.EventHandlerImpl(
      {
        action: act_8797352275194556_emit_7342,
        event: "success",
        displayName: "emit",
      }
    );
    const evh_8797352275194556_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_8797352275194556_success_7341],
      }
    );
    const act_6679522740328543_emit_7344 = new actions.EmitAction(
      {
        actionArgs: this.act_6679522740328543_emit_7344_getActionArgs,
        events: [],
      }
    );
    const evh_6679522740328543_success_7343 = new actions.EventHandlerImpl(
      {
        action: act_6679522740328543_emit_7344,
        event: "success",
        displayName: "emit",
      }
    );
    const evh_6679522740328543_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_6679522740328543_success_7343],
      }
    );
    const act_4848747000340100_showModal_7346 = new actions.ShowModalAction(
      {
        actionArgs: this.act_4848747000340100_showModal_7346_getActionArgs,
        events: [],
      }
    );
    const evh_4848747000340100_clickPreventStop_7345 = new actions.EventHandlerImpl(
      {
        action: act_4848747000340100_showModal_7346,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_4848747000340100_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_4848747000340100_clickPreventStop_7345],
      }
    );
    return {
      act_3573211234170528_emit_7296,
      evh_3573211234170528_success_7295,
      evh_3573211234170528_success,
      act_3350181908999980_emit_7298,
      evh_3350181908999980_success_7297,
      evh_3350181908999980_success,
      act_5626515103939381_emit_7300,
      evh_5626515103939381_success_7299,
      evh_5626515103939381_success,
      act_5072463219534047_emit_7302,
      evh_5072463219534047_success_7301,
      evh_5072463219534047_success,
      act_5450657804282831_emit_7306,
      evh_5450657804282831_close_7305,
      act_5450657804282831_showModal_7304,
      evh_5450657804282831_clickPreventStop_7303,
      evh_5450657804282831_clickPreventStop,
      act_995920279152457_emit_7308,
      evh_995920279152457_clickPreventStop_7307,
      evh_995920279152457_clickPreventStop,
      act_8434031504612555_emit_7310,
      evh_8434031504612555_clickPreventStop_7309,
      evh_8434031504612555_clickPreventStop,
      act_1246756660686207_showModal_7312,
      evh_1246756660686207_clickPreventStop_7311,
      evh_1246756660686207_clickPreventStop,
      act_932298791746317_emit_7316,
      evh_932298791746317_close_7315,
      act_932298791746317_showModal_7314,
      evh_932298791746317_click_7313,
      evh_932298791746317_click,
      act_2674698048827991_emit_7320,
      evh_2674698048827991_success_7319,
      act_2674698048827991_request_7318,
      evh_2674698048827991_click_7317,
      evh_2674698048827991_click,
      act_2252498968068653_emit_7324,
      evh_2252498968068653_close_7323,
      act_2252498968068653_showModal_7322,
      evh_2252498968068653_click_7321,
      evh_2252498968068653_click,
      act_3512640571721973_emit_7328,
      evh_3512640571721973_success_7327,
      act_3512640571721973_request_7326,
      evh_3512640571721973_click_7325,
      evh_3512640571721973_click,
      act_6424219584985303_emit_7332,
      evh_6424219584985303_success_7331,
      act_6424219584985303_request_7330,
      evh_6424219584985303_click_7329,
      evh_6424219584985303_click,
      act_6886333622481462_emit_7336,
      evh_6886333622481462_success_7335,
      act_6886333622481462_request_7334,
      evh_6886333622481462_click_7333,
      evh_6886333622481462_click,
      act_6074864154397733_emit_7340,
      evh_6074864154397733_success_7339,
      act_6074864154397733_request_7338,
      evh_6074864154397733_click_7337,
      evh_6074864154397733_click,
      act_8797352275194556_emit_7342,
      evh_8797352275194556_success_7341,
      evh_8797352275194556_success,
      act_6679522740328543_emit_7344,
      evh_6679522740328543_success_7343,
      evh_6679522740328543_success,
      act_4848747000340100_showModal_7346,
      evh_4848747000340100_clickPreventStop_7345,
      evh_4848747000340100_clickPreventStop,
      reload: act_8434031504612555_emit_7310,
      registerInvoice: act_932298791746317_showModal_7314,
      createInvoicecopy: act_2674698048827991_request_7318,
      createPassThroughInvoice: act_2252498968068653_showModal_7322,
      createAdvanceInvoice: act_3512640571721973_request_7326,
      createFinalInvoice: act_6424219584985303_request_7330,
      createStornoInvoice: act_6886333622481462_request_7334,
      createCorrectorIvoice: act_6074864154397733_request_7338,
    }
  }
}

Vue.component("UcInvoiceHeader", UcInvoiceHeader);

</script>